import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import PropTypes from "prop-types";

function FileManagerDropDown({ direction = "down", handleFirmValue, ...args }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <div className="mr-3">
      <Dropdown color="primary" isOpen={dropdownOpen} toggle={toggle} direction={direction}>
        <DropdownToggle caret style={{ backgroundColor: "#1273EB" }}>
          {selectedValue ? selectedValue : "All"}
        </DropdownToggle>
        <DropdownMenu {...args} right>
          <DropdownItem
            onClick={() => {
              handleFirmValue("all");
              setSelectedValue("All Firms");
            }}
          >
            All Firms
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              handleFirmValue("firms");
              setSelectedValue("Self-Service");
            }}
          >
            Self-Service
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              handleFirmValue("govt_firms");
              setSelectedValue("Government");
            }}
          >
            Government
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

FileManagerDropDown.propTypes = {
  direction: PropTypes.string
};

export default FileManagerDropDown;
